import React, { Component } from "react";
import { Button, Modal, Form, Dropdown } from "semantic-ui-react";
// import { app } from "../..";
// import { queryservice } from "../../services/crudservice";

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      object: null
    };
  }

  updateobject(param, value) {
    let newobject = this.state.object;
    newobject[param] = value;
    //  this.setState({ object: newobject });
  }
  handleupdate() {
    this.props.handleUpdate(this.state.object);
    //  this.setState({ showModal: false });
  }
  genform(type) {
    let wo = this.props.workorder;
    let tempobject = this.state.object;
    if (this.state.object !== null && this.state.showModal === true) {
      switch (type) {
        case "Time and Materials":
          return (
            <Form>
              <Form.Group widths="equal">
                <Form.Input
                  label="Customer Number"
                  value={this.state.object.custnumber}
                  onChange={e =>
                    this.updateobject("custnumber", e.target.value)
                  }
                />
                <Form.Input
                  label="Work Order Number"
                  value={this.state.object.workordernumber}
                  onChange={e =>
                    this.updateobject("workordernumber", e.target.value)
                  }
                />
                <Form.Input
                  label="Ammount"
                  type="number"
                  value={this.state.object.ammount}
                  onChange={e => this.updateobject("ammount", e.target.value)}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Input
                  label="WE Date"
                  type="date"
                  value={this.state.object.wedate}
                  onChange={e => {
                    //loggin for future testing reference
                    console.log(e.target.value);
                    this.updateobject("wedate", e.target.value);
                  }}
                />
                <Form.Input
                  label="Create Date"
                  type="date"
                  value={this.state.object.createdate}
                  onChange={e => {
                    //loggin for future testing reference
                    console.log(e.target.value);
                    this.updateobject("createdate", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.TextArea
                  label="Description"
                  value={this.state.object.description}
                  onChange={e => {
                    this.updateobject("description", e.target.value);
                  }}
                />
              </Form.Group>
            </Form>
          );

          break;
        case "Invoices":
          return (
            <Form>
              <Form.Group widths="equal">
                <Form.Input
                  label="Customer Number"
                  value={this.state.object.custnumber}
                  onChange={e =>
                    this.updateobject("custnumber", e.target.value)
                  }
                />
                <Form.Input
                  label="Work Order Number"
                  value={this.state.object.workordernumber}
                  onChange={e =>
                    this.updateobject("workordernumber", e.target.value)
                  }
                />
                <Form.Input
                  label="Ammount"
                  type="number"
                  value={this.state.object.ammount}
                  onChange={e => this.updateobject("ammount", e.target.value)}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Field>
                  <label>Approver</label>
                  <Dropdown
                    fluid
                    search
                    selection
                    value={this.state.object.approved}
                    options={this.props.approvers}
                    onChange={(e, { value }) => {
                      this.updateobject(value);
                    }}
                  />
                </Form.Field>
                <Form.Input
                  label="Period Begin Date"
                  type="date"
                  value={this.state.object.periodbegindate}
                  onChange={e => {
                    //loggin for future testing reference
                    console.log(e.target.value);
                    this.updateobject("periodbegindate", e.target.value);
                  }}
                />
                <Form.Input
                  label="Period End Date"
                  type="date"
                  value={this.state.object.periodenddate}
                  onChange={e => {
                    //loggin for future testing reference
                    console.log(e.target.value);
                    this.updateobject("periodenddate", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Input
                  label="Submit Date"
                  type="date"
                  value={this.state.object.submitdate}
                  onChange={e => {
                    //loggin for future testing reference
                    console.log(e.target.value);
                    this.updateobject("submitdate", e.target.value);
                  }}
                />
                <Form.Input
                  label="Paid Date"
                  type="date"
                  value={this.state.object.paiddate}
                  onChange={e => {
                    //loggin for future testing reference
                    console.log(e.target.value);
                    this.updateobject("paiddate", e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.TextArea
                  label="Description"
                  value={this.state.object.description}
                  onChange={e => {
                    this.updateobject("description", e.target.value);
                  }}
                />
              </Form.Group>
            </Form>
          );
          break;
      }
    }
  }
  render() {
    return (
      <div>
        <Modal
          dimmer="blurring"
          open={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
        >
          <Modal.Header>Edit {this.props.type}</Modal.Header>
          <Modal.Content>{this.genform(this.props.type)}</Modal.Content>
          <Modal.Actions>
            <Button
              color="red"
              onClick={() => this.setState({ object: null, showModal: false })}
            >
              Cancel
            </Button>
            <Button
              positive
              icon="checkmark"
              labelPosition="right"
              content="Apply Changes"
              onClick={() => this.handleupdate()}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default EditModal;



// WEBPACK FOOTER //
// ./src/components/accounting/editmodal.js